import React from 'react';
import { SemanticToastContainer } from 'react-semantic-toasts';
import autoBind from 'auto-bind';
import MainPage from './MainPage';

class DiscountSettingsPage extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  render() {
    return (
      <>
        <SemanticToastContainer />
        <h1>Discount Settings</h1>
        <br />
        <MainPage />
      </>
    );
  }
}

export default DiscountSettingsPage;
